import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';

import { projectCopy } from '../../../api/Projects/project-methods-client';
import * as projectOps from '../../../api/Projects/project-operations';
import Projects from '../../../api/Projects/Projects';
import { VIDEO_TYPES } from '../../../api/Videos/Videos';

import PageHeader from '../../atoms/PageHeader';
import Loading from '../../components/Loading';
import ProjectItemsListContainer from '../../containers/ProjectItemsListContainer';
import TableListContainer from '../../containers/TableListContainer';
import NotFound from '../NotFound';

const PublicVideoProject = ({ project, authenticated, loading, ...rest }) => {
  if (loading) {
    return <Loading />;
  }
  if (projectOps.isDeleted(project)) {
    return <NotFound />;
  }

  return (
    <>
      <PageHeader>
        <h4 className="mr-3">{projectOps.getName(project)}</h4>
        <small className="text-muted mr-auto">{projectOps.getDescription(project)}</small>
        {authenticated && (
          <ButtonGroup size="sm">
            <Button
              className="ml-auto"
              size="sm"
              onClick={() => projectCopy(project)}
              variant="outline-primary"
            >
              Copy
            </Button>
          </ButtonGroup>
        )}
      </PageHeader>
      <Row>
        <Col xs={12}>
          <TableListContainer
            Page={props => (
              <ProjectItemsListContainer
                project={project}
                hasMap
                isPublic
                types={VIDEO_TYPES.properties}
                {...props}
                {...rest}
              />
            )}
          />
        </Col>
      </Row>
    </>
  );
};

PublicVideoProject.defaultProps = {
  project: {}
};

PublicVideoProject.propTypes = {
  project: PropTypes.object,
  authenticated: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired
};

export default withTracker(({ match }) => {
  const projectId = match.params.project_id;
  const projectSub = Meteor.isClient && Meteor.subscribe('projects.public', projectId);

  return {
    loading: !projectSub || !projectSub.ready(),
    project: Projects.findOne(projectId)
  };
})(PublicVideoProject);
